module.exports = __webpack_public_path__ + "static/img/game-logo-9wicket.1c47624.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-9wicket.png
// module id = uF78
// module chunks = 0 1 2 3 4 5 6